import React from "react";
import { I18n } from "@aws-amplify/core";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loader = props => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      className={props.noDecoration ? "" : "mainContent"}
      style={{
        width: props.width || "100%",
        height: props.height,
        minHeight: "initial"
      }}
    >
      <Grid item>
        <CircularProgress size={30} />
      </Grid>
      <Grid item>
        <Box className="text-54">
          {props.message || I18n.get("common_loading")}
        </Box>
      </Grid>
    </Grid>
  );
};

export default Loader;
